/* global  swal */
import './style.less';

export default function() {
  'ngInject';

  const vm = this;
  vm.$onChanges = loadTable;

  vm.timeStamp = `?time=${new Date().getTime()}`;

  vm.viewMore = () => {
    vm.totalDisplayed += 50;
  };

  vm.delete = (cert, index) => {
    vm.deleteCert({ certificate: cert }).then(() => {
      vm.loadedTable.splice(index, 1);
    });
  };

  function loadTable() {
    vm.loaded = !!vm.tableStatus;
    if (!vm.tableData.length) return (vm.empty = true);
    vm.empty = false;
    vm.totalDisplayed = 50;
    vm.loadedTable = Object.assign([], vm.tableData);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/customTable/controller.js